import axios from 'axios'
import qs from 'qs'
import {
  Message
} from 'element-ui'
import {
  tryHideFullScreenLoading
} from '@/utils/common.js'

// 请求时的拦截器
axios.interceptors.request.use(config => {
  if (config.method === 'post') {
    config.data = qs.stringify(config.data)
  }
  return config
}, error => {
  tryHideFullScreenLoading()
  return Promise.reject(error)
})

// 请求完成后的拦截器
axios.interceptors.response.use(response => {
  return response.data
}, error => {
  tryHideFullScreenLoading()
  return Promise.reject(error)
})

const RES_OK = 0
const xhr = ({
  method = 'get',
  url,
  params = null
}) => {
  return new Promise((resolve, reject) => {
    if (method === 'get') {
      axios.get(url, {
        params: params
      }).then(res => {
        if (res.c === RES_OK) {
          resolve(res.d)
        } else if (res.c === 40004) {
          resolve(res)
        } else {
          tryHideFullScreenLoading()
          reject(res)
          Message.warning(res.m || res.e)
        }
      }).catch(e => {
        tryHideFullScreenLoading()
        Message.warning(e || '请求 API 失败,请检查网络是否正常')
        // Message.warning('请求 API 失败,请检查网络是否正常')
      })
    } else if (method === 'post') {
      axios.post(url, params, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(res => {
        if (url !== '/api/tracking/post') {
          if (res.c === RES_OK) {
            resolve(res.d || res.data)
          } else if (res.c === 40004) {
            resolve(res)
          } else {
            tryHideFullScreenLoading()
            reject(res)
            Message.warning(res.m || res.e)
          }
        } else {
          resolve(res)
        }
      }).catch(e => {
        tryHideFullScreenLoading()
        Message.warning(e || '请求 API 失败,请检查网络是否正常')
      })
    } else {
      //
    }
  })
}

export default xhr



// WEBPACK FOOTER //
// ./src/services/xhr/axios.js